import * as React from 'react';
import { Dialog, DialogType, DialogFooter, PrimaryButton, DefaultButton, Icon, Text } from '@fluentui/react';
import type { IDialogContentProps } from '@fluentui/react';

interface ConfirmationDialogProps {
  visible: boolean;
  title?: string;
  impacts: string[];
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  visible,
  title = 'Confirm Changes',
  impacts,
  onConfirm,
  onCancel,
}) => {
  const dialogContentProps: IDialogContentProps = {
    type: DialogType.normal,
    title,
  };

  return (
    <Dialog
      hidden={!visible}
      onDismiss={onCancel}
      dialogContentProps={dialogContentProps}
      modalProps={{
        isBlocking: true,
        styles: { main: { maxWidth: 500 } },
      }}
    >
      <div style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, marginBottom: 12 }}>
          <Icon
            iconName="Warning"
            style={{ color: '#8a3707', fontSize: 20, marginTop: 2 }}
          />
          <Text style={{ flex: 1 }}>
            Changing these fields will affect the following:
          </Text>
        </div>
        <ul style={{ margin: '8px 0 8px 36px', padding: 0 }}>
          {impacts.map((impact, idx) => (
            <li key={idx} style={{ marginBottom: 8 }}>
              <Text>{impact}</Text>
            </li>
          ))}
        </ul>
        <Text style={{ marginTop: 16, display: 'block' }}>
          Do you want to proceed?
        </Text>
      </div>
      <DialogFooter>
        <PrimaryButton onClick={onConfirm} text="Proceed" />
        <DefaultButton onClick={onCancel} text="Cancel" />
      </DialogFooter>
    </Dialog>
  );
};
